/**
 * Taking an input string, will return as string with hidden characters such as:
 *
 * abcdefghijklmnopqrstuvwxyz = xxxxxxxxxxxxxxxxxxxxxxxxyz
 * abcdefgh = xxxxxxgh
 * abcd = xxxd
 * Any string less than ${charactersToShow} + 2 characters will just be hidden entirely
 * abc = xxx
 *
 * @param str - The input string
 * @param charactersToShow - The amount of characters to show at the end (default 2)
 * @param replaceChar - The character to replace with (default 'x')
 * @returns - The secretized string
 */
export function secretizeString(str: string, charactersToShow = 2, replaceChar = 'x'): string {
    if (replaceChar.length > 1) {
        throw new Error('The replacement char should not be more than 1 character');
    }
    if (str.length <= charactersToShow + 2) {
        return str.replace(/[\s\S]/g, replaceChar);
    }

    let newStr = '';

    for (let i = 0; i < str.length - charactersToShow; i++) {
        newStr += replaceChar;
    }

    newStr += str.substr(str.length - charactersToShow);

    return newStr;
}
